import type { Recipe } from '../types/recipe';
import type { RecipeIndexEntry } from '../services/unifiedRecipeService';

/**
 * What a saved edit changes on the recipe's list entry, so the list shows it
 * before the background refetch lands. Only the fields the edit names.
 *
 * `storedTitle` is the title as stored: the one on screen may be a
 * translation. A changed title drops the translation of the old one
 * (updateRecipe drops it too).
 */
export function recipeIndexEditChanges(updates: Partial<Recipe>, storedTitle: string): Partial<RecipeIndexEntry> {
  return {
    ...(updates.title !== undefined && {
      title: updates.title,
      searchText: updates.title.toLowerCase(),
    }),
    ...(updates.title !== undefined && updates.title.trim() !== storedTitle.trim() && {
      translatedTitles: undefined,
    }),
    ...(updates.readyInMinutes !== undefined && { readyInMinutes: updates.readyInMinutes }),
    // « Préparation » and the shortest « Prêt en » (#850): the cards read them from the index.
    ...(updates.handsOnMinutes !== undefined && { handsOnMinutes: updates.handsOnMinutes }),
    ...(updates.readyInMinutesMin !== undefined && { readyInMinutesMin: updates.readyInMinutesMin }),
    ...(updates.dishTypes !== undefined && { dishTypes: updates.dishTypes }),
    ...(updates.image !== undefined && { image: updates.image }),
  };
}
